/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// constant strings for unit descriptions for the number type of custom field
// Here, the description part will be translated as needed
export const UNITS_SYMBOL_AND_DESCRIPTION_MAP = new Map<string, string>([
	// 'Length'
	['BF', 'Board Feet'],
	['cm', 'Centimeters'],
	['FBM', 'Foot Board Measure'],
	['FT', 'Feet'],
	['IN', 'Inches'],
	['km', 'Kilometers'],
	['LF', 'Linear Feet'],
	['m', 'Meters'],
	['MI', 'Miles'],
	['MIL', '1/1000 Inch'],
	['mm', 'Millimeters'],
	['YD', 'Yards'],
	// 'Area'
	['AC', 'Acres'],
	['CM', 'Circular Mils'],
	['HA', 'Hectares'],
	['km2', 'Square Kilometers'],
	['m2', 'Square Meters'],
	['MCM', 'Thousand Circular Mils'],
	['mm2', 'Square Millimeters'],
	['nm2', 'Net Square Meters'],
	['SF', 'Square Feet'],
	['SI', 'Square Inches'],
	['SY', 'Square Yards'],
	// 'Volume'
	['AC-FT', 'Acre Feet'],
	['CC', 'Cubic Centimeters'],
	['CFM', 'Cubic Feet per Minute'],
	['CFS', 'Cubic Feet per Second'],
	['CU FT', 'Cubic Feet'],
	['CU YD', 'Cubic Yards'],
	['GAL', 'Gallons'],
	['GPD', 'Gallons Per Day'],
	['GPH', 'Gallons Per Hour'],
	['GPM', 'Gallons Per Minute'],
	['GPS', 'Gallons Per Second'],
	['L', 'Liters'],
	['LPD', 'Liters Per Day'],
	['LPM', 'Liters Per Minute'],
	['LPS', 'Liters Per Second'],
	['m3', 'Cubic Meters'],
	['mL', 'Milliliters'],
	['MLD', 'Megaliters per Day'],
	['mm3', 'Cubic Millimeters'],
	// 'Temperature'
	['°C', 'Degrees Celsius'],
	['°F', 'Degrees Farenheit'],
	['°K', 'Degrees Kelvin'],
	['BTU', 'British Thermal Units'],
	['BTUH', 'British Thermal Units per Hour'],
	// 'Electrical'
	['AMP', 'Amperes'],
	['AMPY', 'Ampacity'],
	['CY', 'Cycles'],
	['Hz', 'Hertz'],
	['kHz', 'Kilohertz'],
	['kV', 'Kilovolts'],
	['KVA', 'Kilovolt-Amperes'],
	['kW', 'Kilowatts'],
	['kWH', 'Kilowatt Hours'],
	['mA', 'Milliamperes'],
	['V', 'Volts'],
	['VA', 'Volt Amperes'],
	['VAC', 'Volts AC'],
	// 'Mass'
	['g', 'Grams'],
	['kg', 'Kilograms'],
	['KIP', 'Kilopounds'],
	['LB', 'Pounds'],
	['OZ', 'Ounces'],
	//'Pressure'
	['kPa', 'Kilopascals'],
	['mm Hg', 'Millimeters of Mercury'],
	['MPa', 'Megapascals'],
	['Pa', 'Pascals'],
	['PCF', 'Pounds per Cubic Foot'],
	['PLF', 'Pounds per Lineal Foot'],
	['PSF', 'Pounds per Square Foot'],
	['PSI', 'Pounds per Square Inch'],
	['PSIG', 'Pounds per Square Inch Gage'],
	['VF', 'Vertical Feet of Water Pressure'],
	['VM', 'Vertical Meters of Water Pressure'],
	//'Power'
	['HP', 'Horse Power'],
	['J', 'Joules'],
	['kJ', 'Kilojoules'],
	['MJ', 'Megajoules'],
	['W', 'Watts'],
	//'Time'
	['DAYS', 'Days'],
	['HR', 'Hours'],
	['MIN', 'Minutes'],
	['MO', 'Months'],
	['ms', 'Milliseconds'],
	['SEC', 'Second(s)'],
	['WK', 'Weeks'],
	['YR', 'Years'],
	//'Speed'
	['FPM', 'Feet Per Minute'],
	['FPS', 'Feet Per Second'],
	['KPH', 'Kilometers Per Hour'],
	['MPH', 'Miles Per Hour'],
	['MPS', 'Meters Per Second'],
	['RPM', 'Revolutions Per Minute'],
	//'Force'
	['kN', 'Kilonewtons'],
	['N', 'Newtons'],
	['Nm', 'Newton Meters'],
	//'Other'
	['%', 'Percent'],
	['°', 'Degrees'],
	['C', 'Runoff Coefficient'],
	['CD', 'Candelas'],
	['CPH', 'Changes Per Hour'],
	['CU', 'Coefficient of Utilization'],
	['dB', 'Decibel'],
	['FC', 'Foot-Candles'],
	['FSTC', 'Field Sound Transmission Class'],
	['GA', 'Gauge'],
	['LM', 'Lumens'],
	['LPW', 'Lumens Per Watt'],
	['LUX', 'Lux'],
	['mRem', 'Millirems'],
	['PPM', 'Parts Per Million'],
	['RAD', 'Radians'],
	['STC', 'Sound Transmission Class'],
	['TPD', 'Trips Per Day'],
	['VPD', 'Vehicles Per Day'],
]);
